export var TagStatus;

(function (TagStatus) {
  TagStatus["Active"] = "active";
  TagStatus["Inactive"] = "inactive";
  TagStatus["Deleted"] = "deleted";
})(TagStatus || (TagStatus = {}));